(() => {
  const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function initCarousel(root) {
    if (root.dataset.pxCommerceReady) return;
    root.dataset.pxCommerceReady = 'true';
    const track = root.querySelector('.px-bestsellers-track');
    if (!track) return;
    const buttons = [...root.querySelectorAll('[data-px-best-scroll]')];
    const update = () => buttons.forEach(button => {
      const direction = Number(button.dataset.pxBestScroll);
      button.disabled = direction < 0 ? track.scrollLeft < 2 : track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    });
    buttons.forEach(button => button.addEventListener('click', () => track.scrollBy({ left: Number(button.dataset.pxBestScroll) * (track.clientWidth + parseFloat(getComputedStyle(track).columnGap || 0)), behavior: reducedMotion() ? 'instant' : 'smooth' })));
    track.addEventListener('scroll', update, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
    update();
  }
  function initCategories(root) {
    if (root.dataset.pxCommerceReady) return;
    root.dataset.pxCommerceReady = 'true';
    const tabs = [...root.querySelectorAll('[role=tab]')];
    const panels = [...root.querySelectorAll('[role=tabpanel]')];
    const select = tab => {
      tabs.forEach(button => { button.setAttribute('aria-selected', String(button === tab)); button.tabIndex = button === tab ? 0 : -1; });
      panels.forEach(panel => { panel.hidden = panel.id !== tab.getAttribute('aria-controls'); });
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => select(tab));
      tab.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        else return;
        event.preventDefault(); select(tabs[next]); tabs[next].focus();
      });
    });
  }
  function initFeedback(root) {
    if (root.dataset.pxCommerceReady) return;
    root.dataset.pxCommerceReady = 'true';
    const dialog = root.querySelector('[data-px-feedback-dialog]');
    const launcher = root.querySelector('[data-px-feedback-open]');
    if (!dialog || !dialog.showModal) { launcher.hidden = true; return; }
    const sessionKey = 'hipgaga-feedback-shown-v1';
    const dismissedKey = 'hipgaga-feedback-dismissed-v1';
    const isDismissed = () => { try { return localStorage.getItem(dismissedKey) === '1'; } catch (_) { return root.dataset.pxDismissed === '1'; } };
    const markDismissed = () => { root.dataset.pxDismissed = '1'; try { localStorage.setItem(dismissedKey, '1'); } catch (_) {} };
    const readSession = () => { try { return sessionStorage.getItem(sessionKey); } catch (_) { return root.dataset.pxShown; } };
    const markSession = () => { root.dataset.pxShown = '1'; try { sessionStorage.setItem(sessionKey, '1'); } catch (_) {} };
    let returnFocus = null;
    const show = automatic => {
      if (dialog.open || (automatic && (isDismissed() || readSession() || [...document.querySelectorAll('dialog[open], [aria-modal="true"]')].some(node => node.getClientRects().length && getComputedStyle(node).visibility !== 'hidden')))) return;
      returnFocus = document.activeElement;
      dialog.showModal(); markSession();
    };
    launcher.addEventListener('click', () => show(false));
    root.querySelector('[data-px-feedback-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => { markDismissed(); if (returnFocus?.isConnected) returnFocus.focus(); });
    const readyAt = Date.now() + Math.max(10, Number(root.dataset.delay) || 30) * 1000;
    if (root.dataset.editor !== 'true') document.addEventListener('mouseout', event => {
      if (!event.relatedTarget && event.clientY <= 0 && Date.now() >= readyAt && window.matchMedia('(hover:hover) and (pointer:fine)').matches && !document.hidden) show(true);
    });
    if (root.querySelector('[data-px-feedback-success], [data-px-feedback-errors]')) show(false);
  }
  function init(scope = document) {
    scope.querySelectorAll('[data-px-bestsellers]').forEach(initCarousel);
    scope.querySelectorAll('[data-px-categories]').forEach(initCategories);
    scope.querySelectorAll('[data-px-feedback]').forEach(initFeedback);
  }
  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:block:select', event => {
    const card = event.target.closest('.px-category-card');
    const panel = card?.closest('[role=tabpanel]');
    const tab = panel && document.getElementById(panel.getAttribute('aria-labelledby'));
    tab?.click();
    card?.scrollIntoView({ block: 'nearest', inline: 'nearest' });
  });
})();
